import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: theme.buttonTypes != null ? theme.buttonTypes.transfer : {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
});

const TransferButton = (props) => {
  return (
    <Button className={props.classes.root} {...props}>
      {props.children}
    </Button>
  );
};

TransferButton.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.string.isRequired,
};

export default withStyles(styles)(TransferButton);
